import React from "react";

export const defaultValuechainData = [
  { group: "Health & Safety practices", details: "" },
  { group: "Working conditions", details: "" },
];

const ValueChainAssessmentTable = ({ valuedata = {}, setValueData }) => {
  const normalizedData = Array.isArray(valuedata)
    ? valuedata
    : ["Health & Safety practices", "Working conditions"].map((group) => ({
        group,
        details: valuedata[group] || "",
      }));

  const handleChange = (index, value) => {
    const updated = [...normalizedData];
    updated[index].details = value;
    setValueData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}></th>
            <th style={headerStyle}>
              FY ____ <br />% of value chain partners (by value of business done
              with such partners) that were assessed
            </th>
          </tr>
        </thead>
        <tbody>
          {normalizedData.map((row, index) => (
            <tr key={row.group}>
              <td style={labelStyle}>{row.group}</td>
              <td style={cellStyle}>
                <textarea
                  placeholder="Enter Details"
                  value={row.details}
                  onChange={(e) => handleChange(index, e.target.value)}
                  style={textareaStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "12px",
  border: "1px solid #000",
  textAlign: "center",
  width: "50%",
  wordWrap: "break-word",
};

const labelStyle = {
  padding: "12px",
  border: "1px solid #000",
  backgroundColor: "#F0E9EC",
  fontWeight: "bold",
  textAlign: "left",
  width: "50%",
};

const cellStyle = {
  padding: "12px",
  border: "1px solid #000",
  textAlign: "center",
};

const textareaStyle = {
  width: "100%",
  minHeight: "80px",
  padding: "8px 10px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  resize: "vertical",
  outline: "none",
  boxSizing: "border-box",
};

export default ValueChainAssessmentTable;
